<template>
  
  <form class="spouse-form">

      <div class="panel__block">
        <h2>{{ setFormTitle }} <button v-if="showClearButton()" class="clear-button" @click="clearSpouse">&times;</button></h2>

        <div class="picker-wrap">
          <ClientPicker id="spouse-picker" :field="setField" context="spouse"></ClientPicker>
        </div>

      </div>

  </form>

</template>

<script>

import ClientPicker from './ClientPicker.vue';
 
export default {


	components: {

		ClientPicker,

	}, 

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {  

    setField() {

      return this.$parent.$data.subpanel.field;

    },

    setFieldValue() {

      var client = this.$store.getters.getFieldData({ field: this.$parent.$data.subpanel.field });
      return this.$store.getters.getClientName({ id: client });

    },

    showClearButton() {

      var spouse = this.$store.getters.getClientSpouse();

      if ( spouse !== false ) {

        return true;

      } 

      return false;

    },

    clearSpouse(e) {

      e.preventDefault();

      this.$store.dispatch('saveField', {
        field: 'details.spouse',
        value: false,
      });

      this.$store.dispatch('updateSpouseState', false);

    }

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

    setFormTitle() {

      var vars = this.$parent.getSubpanelData();
      return vars.title + ': ' + this.setFieldValue();

    }

  },

  props : [
  	
    'field',

  ],

  data() {

    return {

    }

  }

}

</script>

<style lang="scss">

  .spouse-form {

    padding: 2rem 0 4rem;
    margin-left: -1.5rem;

    h2 {

      position: relative;

    }

  }

  .picker-wrap {

    padding-left: 1.5rem;
    margin-top: 1.5rem;

  }

  .clear-button {

    display: inline-block;

    background-color: #999;
    color: #fff;
    -webkit-appearance: none;

    border: 0;
    line-height: 1;
    font-size: .7rem;
    border-radius: 10px;

    width: 20px;
    height: 20px;

    position: absolute;
    left: -.5em;
    top: .5em;

    transition: background-color .1s ease, opacity .1s ease, visibility .1s ease;

    &:hover {

      background-color: #f26673;

    }

  }

</style>


// WEBPACK FOOTER //
// SpouseForm.vue?9c2d4172